import React from "react";

function Layout({ children, className = "", ...rest }) {
  return (
    <div className={`content ${className}`} {...rest}>
      {children}
    </div>
  );
}

export default Layout;
